import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import ProgressSection from "../components/ProgressSection";
import ProgressCard from "../components/ProgressCard";
import imagenesMaterias from "../utils/imagenesMaterias";
import { contarTemas, getComplementsCached } from "../services/complementsService";
import { contarProgresoCurso } from "../services/progressUtils";
import { MateriaContenido } from "./MateriaContenido";


function Subjects({ materias, calificaciones, materiaSeleccionada, setMateriaSeleccionada,
  selectedTema, setSelectedTema, user, setModo, refrescarDatosUsuario }) {
  const [complements, setComplements] = useState([]);


  useEffect(() => {
    const fetchComplements = async () => {
      const data = await getComplementsCached();
      setComplements(data);
    };
    fetchComplements();
  }, []);

  const materiasUsuario = complements
    .filter((comp) => materias.some((m) => m.codigo === comp.id))
    .map((comp) => {
      const materiaCurso = materias.find((m) => m.codigo === comp.id);
      return {
        ...comp,
        contenido: materiaCurso?.contenido || "",
      };
    });

  const materiasOrdenadas = [...materiasUsuario].sort((a, b) =>
    a.title.localeCompare(b.title, "es", { sensitivity: "base" })
  );

  return (
    <div className="dashboard-container">
      {!materiaSeleccionada ? (
        <div className="cards-container-materia">
          {materiasOrdenadas.map((materia) => {
            const temasCurso = materia.contenido
              .split("-")
              .filter((item) => item.length <= 4);

            const prog = contarProgresoCurso(calificaciones, temasCurso);

            return (
              <div key={materia.id} onClick={() => setMateriaSeleccionada(materia)}>
                <ProgressCard
                  title={materia.title}
                  color={materia.bgColor}
                  fontColor={materia.fontColor}
                  icon={materia.icon}
                  completed={prog.completed}
                  total={temasCurso.length || 0}
                />
              </div>
            );
          })}
        </div>
      ) : (
        <MateriaContenido
          materia={materiaSeleccionada}
          calificaciones={calificaciones}
          fontColor={materiaSeleccionada.bgColor}
          onVolver={() => setMateriaSeleccionada(null)}
          selectedTema={selectedTema}
          setSelectedTema={setSelectedTema}
          user={user}
          setModo={setModo}
          refrescarDatosUsuario={refrescarDatosUsuario}
        />
      )}
    </div>
  );
}

export default Subjects;
